import Columns3Icon from '@motional/inguitiv/svg/icon/columns-3.svg?react';

function Icon() {
  return <Columns3Icon />;
}

export default Icon;
